import * as React from 'react';

import { FormattedMessage, InjectedIntlProps  } from 'react-intl';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';

import { updateStore } from 'actions/account';
import { AccountStoreForm } from 'components/AccountStoreForm';
import { LayoutHeader } from 'components/Layout';
import { injectIntl } from 'helper/redux';
import { AccountStoreForm as AccountStoreFormModel } from 'models/account';
import { AppState } from 'models/app';

import './AccountStoreUpdate.scss';

interface StateProps {
  initialValues: AccountStoreFormModel;
}

interface DispatchProps {
  updateStore: typeof updateStore;
}

type OwnProps = InjectedIntlProps & RouteComponentProps<{}>;
type AccountStoreUpdateProps = StateProps & DispatchProps & OwnProps;

@injectIntl()
class AccountStoreUpdateContainer extends React.Component<AccountStoreUpdateProps, {}> {
  render() {
    const { history, initialValues, intl } = this.props;
    return (
      <div className="o-container o-container--fluid o-container--fluid-vertical">
        <LayoutHeader actionIcon="ic-close" actionHandler={history.goBack}>
          <h1 className="o-layout-header-title"><FormattedMessage id="account.store.form.title"/></h1>
        </LayoutHeader>
        <AccountStoreForm intl={intl} onSubmit={this.props.updateStore} initialValues={initialValues}/>
      </div>
    );
  }
}

export const AccountStoreUpdate = connect<{}, DispatchProps, OwnProps>(
  (state: AppState) => ({
    initialValues: {
      address: state.accountState.account.store && state.accountState.account.store.storeAddress,
      avatar: state.accountState.account.store && { preview: state.accountState.account.store.avatar },
      name: state.accountState.account.store && state.accountState.account.store.storeName,
      url : state.accountState.account.store && state.accountState.account.store.storeUrl
    }
  }), { updateStore }
)(AccountStoreUpdateContainer);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Account/Store/AccountStoreUpdate/AccountStoreUpdate.tsx